import { useRef, useEffect } from 'react';
import { useInjectReducer, useInjectSaga } from '../../utils/injectors';
import Reducer, { reducer, saga } from './GalleryModal.reducer';

import classNames from "classnames";
import {
  Dialog,
  IconButton,
  Icon,
  Grid,
  AppBar,
  Toolbar,
  Typography,
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';

import './GalleryModal.scss';
import FileViewer from '../../components/FileViewer/FileViewer';

const key = 'GalleryModal';

const GalleryModal = props => {
  const {
    items,
    isOpen,
    activedIndex,
    activedItem,

    setActivedIndex,
    close,
    backIndex,
    nextIndex,
  } = props;

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  const swiperRef = useRef(null);

  const handleChangeIndex = (index) => {
    setActivedIndex({ index: index });
  };
  const handleCarouselItemClick = (index) => {
    setActivedIndex({ index: index });
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.activeIndex !== activedIndex) {
      swiperRef.current.slideTo(activedIndex);
    }
  }, [activedIndex])

  return (
    <>
      <section className={key}>

        <Dialog
          open={isOpen}
          onClose={close}
          className={key}
          fullWidth
          fullScreen
        >

          <AppBar color='secondary' className="app-bar-panel" position="fixed">
            <Toolbar>

              <Typography className="label" component='div' sx={{ flexGrow: 1, alignSelf: 'center' }}>
                <div className='title'>{activedItem?.adapter.displayName}</div>
              </Typography>

              <IconButton
                onClick={close}
                className="button-close"
              >
                <Icon className='icon'>close</Icon>
              </IconButton>
            </Toolbar>
          </AppBar>

          <div
            className='views'
            onClick={(e) => {
              if (e.target.classList.contains('full-screen-frame')) {
                close();
              }
            }}
          >
            <Swiper
              initialSlide={activedIndex}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => handleChangeIndex(swiper.activeIndex)}
            >
              {items.map((x, index) => (
                <SwiperSlide key={index} className='full-screen-frame'>
                  <FileViewer file={x} useOriginalQuality={true} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {
            (items.length > 0) &&
            <Grid container className='view-selector' justifyContent={'center'} alignItems={'center'} flexWrap={'nowrap'}>

              <Grid className='view-selector-button' onClick={backIndex}>
                <IconButton>
                  <Icon className="icon">arrow_back_ios</Icon>
                </IconButton>
              </Grid>

              <Grid className='view-selector-carousel'>
                {items.map((x, index) => (
                  <div
                    id={`${key}-carousel-item-${index}`}
                    key={index}
                    className={classNames(
                      "carousel-item",
                      index === activedIndex && "carousel-item-actived"
                    )}
                    onClick={() => { handleCarouselItemClick(index) }}
                  >
                    <FileViewer file={x} disablePlayer={true} size={{ width: 70, height: 50 }} />
                  </div>
                ))}
              </Grid>

              <Grid className='view-selector-button' onClick={nextIndex}>
                <IconButton>
                  <Icon className="icon">arrow_forward_ios</Icon>
                </IconButton>
              </Grid>

            </Grid>
          }

        </Dialog>

      </section>
    </>
  );
};

export default Reducer.connector({
  isOpen: Reducer.makeSelector('isOpen'),
  items: Reducer.makeSelector('items'),
  activedIndex: Reducer.makeSelector('activedIndex'),
  activedItem: Reducer.makeSelector('activedItem'),
})(GalleryModal);